<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.id ? '编辑故障' : '新建故障'"
      width="500px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-form-item label="分组名称" prop="groupName">
        <el-input v-if="model.id" v-model="model.groupName" disabled="disabled"/>
        <el-input v-else v-model="model.groupName" placeholder="请输入" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.onSelectFaultGroup.open()"/>
        </el-input>
        <fault-group-selector ref="onSelectFaultGroup" @select="onSelectFaultGroup"/>
      </el-form-item>
      <el-form-item label="故障代码" prop="faultCode">
        <el-input v-model="model.faultCode" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="故障描述" prop="faultDesc">
        <el-input
            v-model="model.faultDesc"
            type="textarea"
            :rows="2"
            placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import FaultGroupSelector from "@/views/information/Fault/FaultGroupSelector.vue";

  export default {
    name:"FaultEdit",
    components: {FaultGroupSelector},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false, 
        model: {
          id: 0,
          rowIndex: "",
          faultCode: "",
          faultDesc: "",
          groupID: 0,
          groupName: "",
        },
        ruleValidate: {
          groupName: {required: true, message: "不能为空", trigger: "blur"},
          faultCode: {required: true, message: "不能为空", trigger: "blur"},
          faultDesc: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.model.id = row.id;
          this.model.name = row.name;
          this.model.faultCode = row.faultCode;
          this.model.faultDesc = row.faultDesc;
          this.model.groupID = row.groupID;
          this.model.groupName = row.groupName;
        }
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.model.rowIndex = this.model.faultCode;
            this.submitLoading = true;
            this.$http.save("basic", "faultInfoes", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$message.success("保存成功");
                this.$emit("save-success");
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("保存失败");
              });
          }
        });
      },
      onSelectFaultGroup(row) {
        this.model.groupID = row.id;
        this.model.groupName = row.name;
      },
    },
  };
</script>

<style scoped>

</style>